





































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { vxm } from './../../store.vuex';
import {
  MULTIPLE_CHOICE,
  PARAGRAPH,
  RADIO_BUTTON,
  SHORT_TEXT,
  DROPDOWN,
  DATE_PICKER,
} from '../../models/jobs/CustomFieldType';
import Datepicker from 'vuejs-datepicker';
import {en, de, es, fr} from 'vuejs-datepicker/dist/locale';
import MultiSelect from '@/components/Commons/MultipleSelectWithCheckbox.vue';
@Component({
  components: {
    Datepicker,
    MultiSelect,
  },
})
export default class JobHistoryCustomFields extends Vue {
  $moment: any;
  @Prop() jHistory;
  @Prop() jobHistoryCustomData;
  @Prop() mode;
  @Prop() errors;
  MULTIPLE_CHOICE = MULTIPLE_CHOICE;
  PARAGRAPH = PARAGRAPH;
  RADIO_BUTTON = RADIO_BUTTON;
  SHORT_TEXT = SHORT_TEXT;
  DROPDOWN = DROPDOWN;
  DATE_PICKER = DATE_PICKER;
  private dropdownArr: String[] = [];
  
  get getLanguage() {
    const lang = vxm.users.getUserLang || 'en';
    return {en, de, es, fr}[lang];
  }
  
  mounted() {
    if (
      vxm.jobs.userJobHistoryListResponseCopy.profiles &&
      vxm.jobs.userJobHistoryListResponseCopy.profiles.length
    ) {
      this.jHistory.jobHistoryCustomData['internalProfile'] =
        this.jHistory.jobHistoryCustomData['internalProfile'] ||
        vxm.jobs.userJobHistoryListResponseCopy.profiles[0].name;
      this.setSelectedJobRole(
        (this.jHistory &&
          this.jHistory.jobHistoryCustomData &&
          this.jHistory.jobHistoryCustomData['internalProfile']) ||
          undefined,
        true,
      );
    }
  }

  onSelectMultiSelect(value, fieldName) {
    this.jHistory.jobHistoryCustomData[fieldName] = value
      .map((option) => option.value)
      .join(',');
  }

  getMultiSelectValues(fieldName) {
    if (this.jHistory.jobHistoryCustomData[fieldName]) {
      return this.jHistory.jobHistoryCustomData[fieldName]
        .split(',')
        .map((option) => ({ text: option, value: option }));
    } else {
      return [];
    }
  }

  getLocalDateTime(value) {
    return vxm.utility.convertUTCToLocalTime(value);
  }

  disabledDates(values) {
    if (values.includes('Past') && values.includes('Today')) {
      return { from: new Date(Date.now()) };
    }
    return undefined;
  }

  onDateSelect(date, fieldName) {
    this.jHistory.jobHistoryCustomData[
      fieldName
    ] = vxm.utility.convertLocalTimeToUTC(date);
  }

  get getCompanyDateFormat() {
    return vxm.jobs.getCompanyDateFormat;
  }

  checkRadio(field) {
    return field.type === RADIO_BUTTON &&
      vxm.jobs.UserJobHistoryListResponse.profiles
      ? true
      : false;
  }
  onlyNumber(fieldDataType, $event) {
    //console.log($event.keyCode); //keyCodes value
    if (fieldDataType != 'int') {
      return true;
    }
    let keyCode = $event.keyCode ? $event.keyCode : $event.which;
    if (keyCode < 48 || keyCode > 57) {
      // 46 is dot
      $event.preventDefault();
    }
    return;
  }
  get jobHistoryCustomDataObj() {
    vxm.jobs.UserJobHistoryListResponse.jobHistoryMetaData.forEach(
      (item, idx) => {
        item.placeholder = 'Enter ' + item.label;
      },
    );
    return vxm.jobs.UserJobHistoryListResponse.jobHistoryMetaData;
  }

  jobHistoryCustomDataValues(jobHistoryCustomData) {
    if (!vxm.jobs.userJobHistoryListResponseCopy.profiles) {
      return jobHistoryCustomData;
    }
    const jobRoleField = jobHistoryCustomData.find(
      (data) => data.name === 'internalProfile',
    );
    if (!jobRoleField) {
      return jobHistoryCustomData;
    } else {
      const availableFields = vxm.jobs.UserJobHistoryListResponse.profiles.find(
        (mapping) => mapping.name === jobRoleField.value,
      );
      return jobHistoryCustomData.filter((item) => {
        return availableFields && availableFields.fields.includes(item.id);
      });
    }
  }

  setSelectedJobRole(option = 'Pilot', initCall = false) {
    if (
      !vxm.jobs.userJobHistoryListResponseCopy.profiles ||
      !vxm.jobs.userJobHistoryListResponseCopy.profiles.length
    ) {
      return;
    }
    this.$emit(
      'update-role-help-text',
      option === 'Other'
        ? 'Resume is the only requirement to apply for a position'
        : '',
    );
    const availableFields = vxm.jobs.UserJobHistoryListResponse.profiles.find(
      (mapping) => mapping.name === option,
    );
    var existingResponse = vxm.jobs.UserJobHistoryListResponse;
    var newCustomFields = vxm.jobs.userJobHistoryListResponseCopy.jobHistoryMetaData.filter(
      (item) => {
        return availableFields && availableFields.fields.includes(item.id);
      },
    );
    if (!initCall) {
      Object.keys(this.jHistory.jobHistoryCustomData).forEach((key) => {
        if (key !== 'internalProfile') {
          this.jHistory.jobHistoryCustomData[key] = '';
        }
      });
      this.dropdownArr = [];
    }
    vxm.jobs.setUserJobHistoryListResponse({
      ...existingResponse,
      jobHistoryMetaData: newCustomFields,
    });
  }

  customDataInfo(customDataLabel) {
    if (customDataLabel == 'What is your job role?') return 'Job Role';
    return customDataLabel;
  }

  getCustomDataValue(customData) {
    if (typeof customData.value === 'boolean') {
      return customData.value ? 'Yes' : 'No';
    } else if (customData.type === DATE_PICKER && customData.value) {
      return this.$moment(
        vxm.utility.convertUTCToLocalTime(customData.value),
      ).format('DD-MMM-YYYY');
    }
    return customData.value;
  }

  idDropdownSelected(val: string): boolean {
    return (
      this.jHistory.jobHistoryCustomData[val] &&
      this.jHistory.jobHistoryCustomData[val].length
    );
  }

  changeDropdownStatus(val: string) {
    if (
      this.jHistory.jobHistoryCustomData[val] &&
      !this.dropdownArr.includes(val) &&
      this.jHistory.jobHistoryCustomData[val].length > 0
    ) {
      this.dropdownArr = [...this.dropdownArr, val];
    }
  }
}
